import React from "react";

export function Watermark({ text = "LUMINASTOCK", rows = 8, cols = 5 }) {
  const words = Array.from({ length: rows * cols });
  return (
    <div className="watermark-overlay" aria-hidden="true">
      <div className="watermark-text">
        {words.map((_, i) => (
          <span key={i}>{text}</span>
        ))}
      </div>
    </div>
  );
}
